/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useEffect, useRef, useState } from 'react';
import {
  RootState,
  useAppDispatch,
  statementsRequest,
  statementViewRequest,
  useraccountDetailsRequest,
  useProductName,
  getFullStatements,
  initiateStatementRequest,
  jobStatementRequest,
  setStatmentLoading,
} from '@rb-serve-app/core';
import Spinner from '../../components/Spinner';
import { RightArrow } from '../../assets/svg/ArrowIcon';
import PdfViewer from '../../components/PdfViewer';
import Modal from 'react-modal';
import '../../components/pdfWorkerSetup';
import { useSelector } from 'react-redux';
import { EventType, useAnalytics } from '../../ui/Analytics';
import moment from 'moment';
import { Buffer } from 'buffer';
import Breadcrumbs from '../../components/BreadCrumbs';
import CommanModal from '../../components/CommanModal';
import { pdfjs } from 'react-pdf';
import { useRecaptchaToken } from '@rb-serve-app/core';

// Define props types
const Statements = () => {
  const { trackEvent } = useAnalytics();
  const dispatch = useAppDispatch();
  // Get data from Redux store
  const {
    statements,
    nextEndDate,
    error,
    loading,
    viewStatementFilePath,
    viewStatementError: statementError,
    initialStatement,
    jobStatus,
    loaderPercentage,
  } = useSelector((state: RootState) => state.statements);
  const { customerId, accountId, accountDetails } = useSelector(
    (state: RootState) => state.user
  );
  // const [currentStatement, ...previousStatements] = statements;

  const { contentfulData } = useSelector(
    (state: { contentful: any }) => state.contentful
  );
  const getRecaptchaToken = useRecaptchaToken();
  const { entries, assets } = contentfulData;
  const rb_statements = entries?.rb_statements;
  const rb_common = entries?.rb_common;
  const lastLoadedDate = useRef('');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [errorModalIsOpen, setErrorModalIsOpen] = useState(false);
  const [modalHeadingMessage, setModalHeadingMessage] = useState('');
  const [modalSubMsg, setModalSubMsg] = useState('');
  const [viewStatementError, setViewStatementError] = useState(false);
  const [progress, setProgress] = useState(0);
  const [userFriendlyMsg, setUserFriendlyMsg] = useState('');
  const [errorMessage, setErrorMessage] = useState({
    title: rb_common?.commonString?.error || '',
    description: rb_common?.commonString?.unknownErrOccured || '',
  });
  const [pdfFile, setPdfFile] = useState<string | File | null>(null);
  const [selectedStatementDates, setSelectedStatementDates] = useState({
    fromDate: '',
    toDate: '',
  });
  const [selectedStatement, setSelectedStatement] = useState({
    statementId: '',
    statementDate: '',
    cycleDate: '',
  });
  const [retryCount, setRetryCount] = useState(0); // Current retry count
  const { cardStructure, productName } = useProductName();
  const requestRecaptchaToken = async (action: string) => {
    return await getRecaptchaToken(action);
  };

  const openModal = async (
    statementId: string,
    statementDate: string,
    cycleDate: string
  ) => {
    const selfServe = {
      type: 'inquiry',
      category: 'rogersbank-cross platform-view-statements',
    };

    trackEvent(
      EventType.PAGE_VIEW,
      'view statement-modal',
      window.location.href,
      undefined,
      true,
      selfServe
    );

    setViewStatementError(false);
    // setPdfFile(null);
    setModalIsOpen(true);

    if (accountId && customerId && statementId) {
      setSelectedStatement({
        statementId,
        statementDate,
        cycleDate,
      });
      dispatch(
        initiateStatementRequest({
          accountId,
          customerId,
          statementId: statementId,
          statementDate: statementDate,
          cycleDate: cycleDate,
          isRefresh: true,
        })
      );
      setUserFriendlyMsg(
        rb_statements?.statementConfig?.userFriendlyMsg['1'] || ''
      );
    }
    setSelectedStatementDates({
      fromDate: formatPastDate(statementDate),
      toDate: formatDate(statementDate),
    });
  };
  useEffect(() => {
    setProgress(loaderPercentage);
  }, [loaderPercentage]);

  useEffect(() => {
    if (error || statementError) {
      setErrorMessage({
        title: rb_common?.commonString?.error || '',
        description: rb_common?.commonString?.unknownErrOccured || '',
      });
      setViewStatementError(true);
      setErrorModalIsOpen(false);
    }
  }, [error, statementError]);

  useEffect(() => {
    if (initialStatement) {
      console.log(initialStatement, 'initialStatement');
      setViewStatementError(false);
      const { jobId, status } = initialStatement;
      if (jobId && status === 'COMPLETE') {
        dispatch(
          statementViewRequest({
            accountId,
            customerId,
            statementId: selectedStatement.statementId,
            statementDate: selectedStatement.statementDate,
            cycleDate: selectedStatement.cycleDate,
            recaptchaToken: requestRecaptchaToken,
          })
        );
      } else if (jobId && status === 'FAILED') {
        setErrorMessage({
          title: rb_common?.commonString?.error || '',
          description: rb_common?.commonString?.unknownErrOccured || '',
        });
        setViewStatementError(true);
        dispatch(setStatmentLoading(false));
      } else if (jobId && status === 'PENDING') {
        setRetryCount((prev) => prev + 1);
        dispatch(
          jobStatementRequest({
            accountId,
            customerId,
            jobId,
            statementId: selectedStatement.statementId,
            statementDate: selectedStatement.statementDate,
            cycleDate: selectedStatement.cycleDate,
            isRefresh: true,
          })
        );
      }
    }
  }, [initialStatement]);

  useEffect(() => {
    if (jobStatus === null) return;
    if (jobStatus) {
      setViewStatementError(false);
      if (jobStatus === 'PENDING') {
        if (retryCount < rb_statements?.statementConfig?.maxRetryCount) {
          setTimeout(
            () => {
              if (
                retryCount * rb_statements?.statementConfig?.pollingInterval >=
                15
              ) {
                setUserFriendlyMsg(
                  rb_statements?.statementConfig?.userFriendlyMsg?.['2'] || ''
                );
              }
              setRetryCount((prev) => prev + 1);
              dispatch(
                jobStatementRequest({
                  accountId,
                  customerId,
                  jobId: initialStatement?.jobId,
                  statementId: selectedStatement.statementId,
                  statementDate: selectedStatement.statementDate,
                  cycleDate: selectedStatement.cycleDate,
                  isRefresh: true,
                })
              );
            },
            rb_statements?.statementConfig?.pollingInterval * 1000 || 3000
          ); // Default to 3 seconds if not set
        } else {
          console.log('Max retry attempts reached. Stopping further requests.');
          setErrorMessage({
            title: rb_common?.commonString?.error || '',
            description:
              rb_statements?.statementConfig?.userFriendlyMsg?.['3'] || '',
          });
          setViewStatementError(true);
          dispatch(setStatmentLoading(false));
        }
      } else if (jobStatus === 'COMPLETE') {
        dispatch(
          statementViewRequest({
            accountId,
            customerId,
            statementId: selectedStatement.statementId,
            statementDate: selectedStatement.statementDate,
            cycleDate: selectedStatement.cycleDate,
            recaptchaToken: requestRecaptchaToken,
          })
        );
      } else if (jobStatus === 'FAILED') {
        setErrorMessage({
          title: rb_common?.commonString?.error || '',
          description: rb_common?.commonString?.unknownErrOccured || '',
        });
        setViewStatementError(true);
        dispatch(setStatmentLoading(false));
      }
    }
  }, [jobStatus]);

  const closeModal = () => {
    trackClickEvent('view statement modal | close');
    setModalIsOpen(false);
    setPdfFile(null);
    setViewStatementError(false);
  };

  useEffect(() => {
    if (error || statementError) {
      setErrorMessage({
        title: rb_common?.commonString?.error || '',
        description: rb_common?.commonString?.unknownErrOccured || '',
      });
      setViewStatementError(true);
      setErrorModalIsOpen(true);
    }
  }, [error, statementError]);
  const getDownloadFileLabel = (value?: string) => {
    if (!value) return 'statement';

    const replaceAll = (input: string, pattern: RegExp, replacement: string) =>
      (String.prototype as any).replaceAll.call(
        input,
        pattern,
        replacement
      ) as string;
    const htmlTagPattern = /<[^>]+>/g;
    const invalidFileCharPattern = /[<>:"/\\|?*]/g;
    const multiWhitespacePattern = /\s+/g;

    const text =
      typeof DOMParser === 'undefined'
        ? replaceAll(value, htmlTagPattern, ' ')
        : new DOMParser().parseFromString(value, 'text/html').body
            .textContent || value;

    const withoutInvalidChars = replaceAll(text, invalidFileCharPattern, ' ');
    return replaceAll(withoutInvalidChars, multiWhitespacePattern, ' ').trim();
  };

  const downloadFile = async (file: string) => {
    const token = await getRecaptchaToken('statementdownload');

    trackEvent(
      EventType.CLICK_EVENT,
      'view statement-modal',
      window.location.href,
      'view statement modal | download',
      false,
      {
        type: 'enquiry',
        category: 'rogersbank-cross platform-view-statements-download-pdf copy',
      },
      undefined,
      false,
      {},
      true
    );
    // const blob = new Blob([viewStatement], { type: 'application/pdf' });

    const name = getDownloadFileLabel(productName);
    const cardLast4 = accountDetails?.customer?.cardLast4;
    const date = moment(
      selectedStatementDates.toDate,
      'MMM DD, YYYY',
      locale
    ).toDate();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const fileName = `${name}_${cardLast4}_${month}_${year}`;

    const link = document.createElement('a');
    link.href = viewStatementFilePath;
    link.download = `${fileName}.pdf`;
    link.click();
  };

  const trackClickEvent = (name: string) => {
    trackEvent(
      EventType.CLICK_EVENT,
      viewStatementFilePath ? 'view statement-modal' : 'statements',
      window.location.href,
      `${name}`
    );
  };

  useEffect(() => {
    trackEvent(EventType.PAGE_VIEW, 'statements', window.location.href);
  }, []);

  const fetchStatements = useCallback(
    (accountId: string, customerId: string, nextEndDate: string) => {
      dispatch(statementsRequest({ accountId, customerId, nextEndDate }));
    },
    [dispatch]
  );

  const handleLoadMore = () => {
    trackClickEvent('statements|load more');
    fetchStatements(accountId, customerId, nextEndDate);
  };

  useEffect(() => {
    if (accountId && customerId && !statements.length) {
      fetchStatements(accountId, customerId, nextEndDate);
    }
  }, [
    dispatch,
    accountId,
    customerId,
    statements.length,
    fetchStatements,
    nextEndDate,
  ]);

  const fullStatements = getFullStatements(
    accountDetails,
    statements,
    nextEndDate,
    lastLoadedDate.current
  );

  const previousStatements =
    fullStatements.length > 0 ? fullStatements.slice(1) : [];

  const sortedPreviousStatements: any = [...new Set(previousStatements)].sort(
    (a: any, b: any) => moment(b.statementDate).diff(moment(a.statementDate))
  );

  const dataList = [
    {
      title: rb_statements.currentTitle,
      data: fullStatements.length > 0 ? [fullStatements[0]] : [],
    },
    {
      title: rb_statements.previousTitle,
      data: sortedPreviousStatements,
    },
  ];
  if (
    sortedPreviousStatements[sortedPreviousStatements.length - 1]?.cycleDate
  ) {
    lastLoadedDate.current =
      sortedPreviousStatements[sortedPreviousStatements.length - 1]?.cycleDate;
  }
  console.log(
    'cycledattee',
    sortedPreviousStatements[sortedPreviousStatements.length - 1]?.cycleDate
  );

  const setupLocale = () => {
    try {
      const deviceLocale = localStorage.getItem('language');
      const localeToUse = deviceLocale === 'fr' ? 'fr' : 'en';

      moment.locale(localeToUse);

      return localeToUse;
    } catch (error) {
      console.warn('Error setting moment locale:', error);
      moment.locale('en');
      return 'en';
    }
  };
  const locale = setupLocale();

  const formatDate = (
    date: string | undefined,
    isPlaceholder = false
  ): string => {
    if (date === undefined || date === null) {
      return 'NA';
    }

    if (isPlaceholder) {
      const momentDate = moment(date, 'YYYY-MM-DD');
      if (momentDate.isValid()) {
        return momentDate.format('MMM DD, YYYY');
      } else {
        console.log('Invalid placeholder date:', date);
        return 'Invalid Date';
      }
    }
    return moment(date).format('MMM DD, YYYY');
  };

  const formatPastDate = (date: string) =>
    moment(date).subtract(1, 'months').add(1, 'days').format('MMM DD, YYYY');
  const [numPages, setNumPages] = useState<number>(0);
  useEffect(() => {
    if (viewStatementFilePath) {
      setPdfFile(null);
      setNumPages(0);
      try {
        // const bufferData = Buffer.from(viewStatement);
        // const blob = new Blob([bufferData], { type: 'application/pdf' });
        // const file = new File([blob], 'downloaded.pdf', {
        //   type: 'application/pdf',
        // });
        setPdfFile(viewStatementFilePath);
        setViewStatementError(false);
        const loadingTask = pdfjs.getDocument(viewStatementFilePath);
        loadingTask.promise
          .then((pdf) => {
            setNumPages(pdf.numPages);
          })
          .catch((error) => {
            console.error('Error loading PDF:', error);
            setViewStatementError(true);
          });
      } catch (error) {
        console.error('Error occurred while processing viewStatement:', error);
        setViewStatementError(true);
      }
    }
  }, [viewStatementFilePath]);

  useEffect(() => {
    if (viewStatementError) {
      setModalHeadingMessage(rb_statements?.stmtErrorTitle);
      setModalSubMsg(rb_statements?.stmtErrorSubtitle);
      setErrorModalIsOpen(true);
    }
  }, [viewStatementError]);

  const closeErrorModal = () => {
    setErrorModalIsOpen(false);
    setViewStatementError(false);
    setModalIsOpen(false);
  };

  const fetchAccountDetails = useCallback(() => {
    if (accountId) {
      if (!accountDetails?.customer?.cardLast4) {
        //  dispatch(useraccountDetailsRequest({ accountId, customerId }));
      }
    }
  }, [accountId, customerId, dispatch]);
  useEffect(() => {
    fetchAccountDetails();
  }, [fetchAccountDetails]);

  const breadcrumbs = [
    {
      name: entries?.rb_navigation?.homeLogoTitle,
      href: '/home',
      icon: '/path/to/home-icon.png',
    },
    { name: entries?.rb_view_statements?.viewStatementCtaTitle, href: '' },
  ];

  return (
    <div>
      {rb_statements ? (
        <div className="bg-bg-body py-4 px-8 h-full flex flex-col">
          <Breadcrumbs items={breadcrumbs} />

          <main className="bg-white p-[30px] lg:rounded-lg shadow-none flex-1 flex-col overflow-y-scroll scrollbar-hide">
            <h2
              className="md:text-2xl font-bold text-[16px]"
              aria-label={rb_statements.statementTitle}
            >
              {rb_statements.statementTitle}
            </h2>
            <div className="hidden md:flex bg-[#f5f5f5] lg:rounded-lg shadow flex-row items-center p-5 mt-5 mb-5">
              <img
                src={cardStructure?.imgUrl}
                alt="cardImg"
                className="h-[90px]"
              />
              <div className="ml-5">
                <h3
                  className="font-bold text-lg"
                  aria-label={`${productName} ${accountDetails?.customer?.cardLast4}`}
                >
                  <span
                    dangerouslySetInnerHTML={{
                      __html: productName || '',
                    }}
                  />{' '}
                  {accountDetails?.customer?.cardLast4}
                </h3>
              </div>
            </div>
            <div className="block md:hidden">
              <h3
                className="font-normal text-lg mt-4"
                aria-label={`${productName} ${accountDetails?.customer?.cardLast4}`}
              >
                <span
                  dangerouslySetInnerHTML={{
                    __html: productName || '',
                  }}
                />{' '}
                {accountDetails?.customer?.cardLast4}
              </h3>
            </div>
            <section className="mt-10" aria-labelledby="current-statements">
              {!loading ? (
                <>
                  {dataList[0].data.length === 0 &&
                    dataList[1].data.length === 0 && (
                      <div
                        className="flex flex-col gap-4 items-center justify-center"
                        aria-live="polite"
                      >
                        <img
                          className="w-1/3"
                          src={assets.no_statement_icon}
                          alt="No statements available icon"
                        />
                        <p>{rb_statements.noStatementsTitle}</p>
                      </div>
                    )}
                  {(dataList[0].data.length > 0 ||
                    dataList[1].data.length > 0) && (
                    <div className="items-center justify-center">
                      <h3 id="current-statements">
                        {rb_statements.currentTitle}
                      </h3>
                      <button
                        type="button"
                        className="md:bg-[#fafafa] bg-white xl:w-[24%] sm:w-[48%] lg:w-[32.5%] w-full flex md:rounded-lg items-center px-5 py-2 md:px-5 md:py-4 mt-0 md:mt-5 cursor-pointer lg:border-none border-b border-[#E9E9E9] text-left"
                        onClick={() => {
                          if (dataList[0].data[0]?.statementId?.trim()) {
                            trackClickEvent(
                              `current | ${formatDate(
                                dataList[0].data[0]?.statementDate
                              )}`
                            );
                            openModal(
                              dataList[0].data[0]?.statementId,
                              dataList[0].data[0]?.statementDate,
                              dataList[0].data[0]?.cycleDate
                            );
                          }
                        }}
                        aria-label={`Open ${formatDate(
                          dataList[0].data[0]?.statementDate
                        )} statement`}
                      >
                        <img
                          src={assets.statement_icon}
                          className="w-14 h-14 bg-white p-3 lg:rounded-full"
                          alt="Statement icon"
                        />
                        <div className="flex-1 text-left ml-3">
                          {dataList[0].data[0]?.statementId?.trim() ? (
                            <p>
                              {formatDate(dataList[0].data[0]?.statementDate)}
                            </p>
                          ) : (
                            <>
                              <p>
                                {formatDate(
                                  dataList[0].data[0]?.statementDate,
                                  true
                                )}
                              </p>
                              <p>{rb_statements.noStatement}</p>
                            </>
                          )}
                        </div>

                        {dataList[0].data[0]?.statementId?.trim() && (
                          <RightArrow fill="#DA291C" aria-hidden="true" />
                        )}
                      </button>

                      {dataList[1].data.length > 0 && (
                        <h3 id="previous-statements" className="mt-10">
                          {rb_statements.previousTitle}
                        </h3>
                      )}
                      <div
                        className="grid  grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4  gap-0 md:gap-6 mt-0 md:mt-5"
                        role="list"
                      >
                        {dataList[1].data?.map(
                          (statement: any, index: number) => (
                            <button
                              key={index}
                              type="button"
                              className="md:bg-[#fafafa] bg-white md:rounded-lg w-full flex items-center justify-center px-5 py-2 md:px-5 md:py-4 cursor-pointer lg:border-none border-b border-[#E9E9E9] text-left"
                              onClick={() => {
                                if (statement?.statementId?.trim()) {
                                  trackClickEvent(
                                    `previous | ${formatDate(
                                      statement.statementDate
                                    )}`
                                  );
                                  openModal(
                                    statement?.statementId,
                                    statement?.statementDate,
                                    statement?.cycleDate
                                  );
                                }
                              }}
                              aria-label={`Open statement ${index + 1}`}
                            >
                              <img
                                src={assets.statement_icon}
                                className="w-14 h-14 bg-white p-3 lg:rounded-full"
                                alt={`Statement icon ${index + 1}`}
                              />
                              <div className="flex-1 text-left ml-3">
                                {statement.statementId?.trim() ? (
                                  <p>{formatDate(statement.statementDate)}</p>
                                ) : (
                                  <>
                                    <p>
                                      {formatDate(
                                        statement.statementDate,
                                        true
                                      )}
                                    </p>
                                    <p>{rb_statements.noStatement}</p>
                                  </>
                                )}
                              </div>
                              {statement.statementId?.trim() && (
                                <RightArrow fill="#DA291C" aria-hidden="true" />
                              )}
                            </button>
                          )
                        )}
                      </div>
                      {nextEndDate && (
                        <button
                          className="flex justify-center text-blue-600 p-8 underline items-center w-full"
                          aria-label={rb_statements.loadMoreTitle}
                          onClick={handleLoadMore}
                        >
                          {rb_statements.loadMoreTitle}
                        </button>
                      )}
                    </div>
                  )}
                </>
              ) : (
                <div className="flex justify-center items-center h-[80vh]">
                  <Spinner aria-label="Loading statements" />
                </div>
              )}
            </section>
          </main>
        </div>
      ) : (
        <div className="flex justify-center items-center h-[80vh]">
          <Spinner aria-label="Loading statements" />
        </div>
      )}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="PDF Viewer"
        className="fixed inset-0 bg-white p-0 m-0 flex flex-1"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50"
        ariaHideApp={false}
        shouldCloseOnOverlayClick={true}
      >
        {viewStatementError ? (
          <CommanModal
            isOpen={errorModalIsOpen}
            jsxContent={
              <>
                <div
                  aria-label={errorMessage?.title}
                  className="mt-[20px] text-lg font-semibold text-center"
                >
                  {errorMessage?.title}
                </div>
                <div
                  aria-label={errorMessage?.description}
                  className="mt-[20px]"
                >
                  {errorMessage?.description}
                </div>
              </>
            }
            onClose={closeErrorModal}
            buttonText={rb_common?.commonString?.ok}
            cardStatus={true}
            closeIcon={false}
          />
        ) : (
          <PdfViewer
            fromDate={selectedStatementDates.fromDate}
            toDate={selectedStatementDates.toDate}
            file={pdfFile}
            onClose={closeModal}
            onDownload={downloadFile}
            pageCount={numPages}
            progress={progress}
            userFriendlyMsg={userFriendlyMsg}
          />
        )}
      </Modal>
    </div>
  );
};

export default Statements;
